import { z } from 'zod';
import { provinceCodeSchema } from './common.js';

/** Customer identity: Telegram id + phone + saved addresses (CLAUDE.md §3). */

export const customerAddressSchema = z.object({
  id: z.string().uuid(),
  label: z.string().nullable(),
  receiverName: z.string(),
  phone: z.string(),
  provinceCode: provinceCodeSchema,
  district: z.string().nullable(),
  addressLine: z.string(),
  note: z.string().nullable(),
  isDefault: z.boolean(),
});
export type CustomerAddressDto = z.infer<typeof customerAddressSchema>;

export const upsertAddressSchema = z.object({
  label: z.string().max(40).nullable().optional(),
  receiverName: z.string().min(1).max(80),
  phone: z.string().min(6).max(24),
  provinceCode: provinceCodeSchema,
  district: z.string().max(80).nullable().optional(),
  addressLine: z.string().min(3).max(300),
  note: z.string().max(300).nullable().optional(),
  isDefault: z.boolean().default(false),
});

export const customerSchema = z.object({
  id: z.string().uuid(),
  telegramUserId: z.number().int().nullable(),
  name: z.string().nullable(),
  phone: z.string().nullable(),
  orderCount: z.number().int(),
  totalSpent: z.object({ amount: z.number().int(), currency: z.enum(['USD', 'KHR']) }),
  lastOrderAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
});
export type CustomerDto = z.infer<typeof customerSchema>;

export const updateCustomerSchema = z.object({
  name: z.string().max(80).nullable().optional(),
  phone: z.string().max(24).nullable().optional(),
  notes: z.string().max(1000).nullable().optional(),
});
